export namespace MandantenNotificationTypes {
    export const MANDANT_CONFIG_UPDATED_NOTIFICATION = 'MANDANT.CONFIGUPDATED';
    
}

